import { render } from "./user-reviews-index.vue?vue&type=template&id=1ff69773"
import script from "./user-reviews-index.vue?vue&type=script&lang=js"
export * from "./user-reviews-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__